<!--
 * @Description: switch
 * @Autor: lwq
 * @Date: 2020-07-17 14:53:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-16 10:45:47
 * @FilePath: \mrc-base-server-view\src\components\mrc_ess_switch.vue
-->
<template>
  <v-switch :true-value="trueValue"
            :false-value="falseValue"
            :input-value="status"
            :disabled="readonly"
            :label="showlabel"
            v-bind="$attrs"
            v-on="$listeners">
  </v-switch>
</template>

<script>
/**
 * @description:
 * @param {trueValue} true的值
 * @param {falseValue} false的值
 * @param {status} 绑定的值
 * @param {trueText} 为true显示的文本
 * @param {falseText} 为false显示的文本
 * @return:
 * @author: lwq
 */
export default {
  components: {},
  props: {
    trueValue: {
      type: [String, Number, Boolean],
      default: true,
    },
    falseValue: {
      type: [String, Number, Boolean],
      default: false,
    },
    status: {
      type: [String, Number, Boolean],
      default: true,
    },
    trueText: {
      type: String,
    },
    falseText: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
  },
  model: {
    prop: 'status',
    event: 'change',
  },
  data () {
    return {}
  },
  computed: {
    showlabel () {
      if (this.label) {
        return this.label
      } else {
        return this.status == this.trueValue
          ? this.trueText || this.$t('label_To_enable_the')
          : this.falseText || this.$t('label_disable')
      }
    },
  },
  created () { },
  watch: {},
  mounted () { },

  methods: {
    change (val) {
      this.$emit('change', val)
    },
  },
}
</script>

<style scoped></style>
